import { Pagination } from '@web/components/ui/pagination';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@web/components/ui/table';

type ProceduresTableProps = {
  procedures?: {
    id: string;
    displayName: string;
    name: string;
    price: number;
    category: string;
  }[];
  onDetails?: (procedure: { id: string }) => void;
  pagination?: {
    currentPage: number;
    totalPages: number;
    totalItems: number;
    pageSize: number;
    onPageChange: (page: number) => void;
    onPageSizeChange: (pageSize: number) => void;
  };
};

export function ProceduresTable({
  procedures,
  onDetails,
  pagination,
}: ProceduresTableProps) {
  return (
    <div>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Display Name</TableHead>
            <TableHead>Name</TableHead>
            <TableHead>Price</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {procedures?.map((procedure) => (
            <TableRow
              key={procedure.id}
              onClick={
                onDetails
                  ? () => {
                      onDetails(procedure);
                    }
                  : undefined
              }
              className="hover:bg-muted/50 cursor-pointer"
            >
              <TableCell>{procedure.displayName}</TableCell>
              <TableCell>{procedure.name}</TableCell>
              <TableCell>$ {procedure.price}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {pagination && (
        <Pagination
          currentPage={pagination.currentPage}
          totalPages={pagination.totalPages}
          totalItems={pagination.totalItems}
          pageSize={pagination.pageSize}
          onPageChange={pagination.onPageChange}
          onPageSizeChange={pagination.onPageSizeChange}
        />
      )}
    </div>
  );
}
